import { Inject, Injectable } from '@angular/core';
import { TInputAppEnvironmentVars } from '@monorepo/types';

const ComponentLineInEndPoints = {
  FETCH_COMPONENT_TAG_WIP_INFO: 'FETCH_COMPONENT_TAG_WIP_INFO',
  FETCH_COMPONENT_TAG_WIP_INFO_BY_MASTER_BUNDLE_TAG: 'FETCH_COMPONENT_TAG_WIP_INFO_BY_MASTER_BUNDLE_TAG',
  SAVE_COMPONENT_TAGS: 'SAVE_COMPONENT_TAGS',
  FETCH_TRANSACTION_LOG: 'FETCH_TRANSACTION_LOG',
  TRANSACTION_DETAILS: 'TRANSACTION_DETAILS',
  UNDO_COMPONENT_TAGS: 'UNDO_COMPONENT_TAGS',
  FETCH_BUNDLE_TRANSACTION_LOG: 'FETCH_BUNDLE_TRANSACTION_LOG',
  BUNDLE_TRANSACTION_DETAILS: 'BUNDLE_TRANSACTION_DETAILS',
  GET_COMPONENT_TAG_PROCESS_HISTORY: 'GET_COMPONENT_TAG_PROCESS_HISTORY',
  BUNDLE_TAG_UNDO: 'BUNDLE_TAG_UNDO',
};

type TComponentLineInEndPoints = typeof ComponentLineInEndPoints;
type TComponentLineInEndPointsTypes = keyof TComponentLineInEndPoints;
type TEnvVariables = TComponentLineInEndPoints;

@Injectable({
  providedIn: 'root',
})
export class AssemblyInEnvProvider {
  private env_vars!: TEnvVariables;
  private protocol = 'http';
  private service_host = '';
  private tags_services = '';
  private bulk_count_app_services = '';
  constructor(@Inject('environment') ENV: TInputAppEnvironmentVars) {
    if (ENV.protocol !== null) {
      this.protocol = ENV.protocol;
    }
    if (ENV.service_host !== null) {
      this.service_host = ENV.service_host;
    }
    if (ENV.tags_services !== null) {
      this.tags_services = ENV.tags_services;
    }
    if (ENV.bulk_count_app_services !== null) {
      this.bulk_count_app_services = ENV.bulk_count_app_services;
    }
    this.registerVars();
  }

  registerVars() {
    const HOST_DOMAIN_WITH_PROTOCOL = this.protocol + this.service_host;
    const TAGS_SERVICE_URL = HOST_DOMAIN_WITH_PROTOCOL + this.tags_services;
    const GENERIC_APP_SERVICE_URL = HOST_DOMAIN_WITH_PROTOCOL + this.bulk_count_app_services;

    this.env_vars = {
      FETCH_COMPONENT_TAG_WIP_INFO: TAGS_SERVICE_URL + '/cpm/api/getComponentTagWipInfo',
      FETCH_COMPONENT_TAG_WIP_INFO_BY_MASTER_BUNDLE_TAG:
        TAGS_SERVICE_URL + '/cpm/api/v1/bulk/getComponentWipInfoByBundleTag',
      SAVE_COMPONENT_TAGS: GENERIC_APP_SERVICE_URL + '/api/v1/componentsGroup/bulk/add',
      FETCH_TRANSACTION_LOG: GENERIC_APP_SERVICE_URL + '/api/v1/componentsGroup/componentTag/transactions',
      TRANSACTION_DETAILS: GENERIC_APP_SERVICE_URL + '/api/v1/componentsGroup/componentTag/details',
      UNDO_COMPONENT_TAGS: GENERIC_APP_SERVICE_URL + '/api/v1/componentsGroup/undo',
      FETCH_BUNDLE_TRANSACTION_LOG: GENERIC_APP_SERVICE_URL + '/api/v1/componentsGroup/bundleTag/transactions',
      BUNDLE_TRANSACTION_DETAILS: GENERIC_APP_SERVICE_URL + '/api/v1/componentsGroup/bundleTag/details',
      GET_COMPONENT_TAG_PROCESS_HISTORY: TAGS_SERVICE_URL + '/cpm/api/v1/getComponentTagProcessHistory',
      BUNDLE_TAG_UNDO: GENERIC_APP_SERVICE_URL + '/api/v1/cutTag/undo',
    };
  }

  getEnvVar(key: TComponentLineInEndPointsTypes): string {
    return this.env_vars[key];
  }
}
